import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal } from "@/components/erp/ui";
import { ScanInput } from "@/components/erp/prod/ProdInputs";

const fmt = (s) => (s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

// Cek label QR spool pakai kamera HP / ketik kode
export const SpoolCheck = ({ open, onClose }) => {
  const [code, setCode] = useState("");
  const [s, setS] = useState(null);
  useEffect(() => {
    if (!/^SPL\d{5,}$/.test(code)) { setS(null); return; }
    api.get(`/spools/by-code/${code}`).then(({ data }) => setS(data)).catch(() => setS({ missing: true }));
  }, [code]);
  return (
    <Modal open={open} onClose={() => { setCode(""); onClose(); }} title="Cek Label Barang">
      <ScanInput testid="spool-check-code" value={code} onChange={setCode} />
      {s?.missing && <p className="text-sm text-rose-600 mt-3" data-testid="spool-check-missing">Kode {code} tidak ditemukan.</p>}
      {s && !s.missing && (
        <div className="mt-3 rounded-lg bg-slate-50 p-3 grid grid-cols-2 gap-1 text-sm" data-testid="spool-check-result">
          <span className="text-slate-500">Kode</span><b>{s.code}</b>
          <span className="text-slate-500">Material</span><span>{s.material} {s.color}</span>
          <span className="text-slate-500">Masuk</span><span data-testid="spool-check-date">{fmt(s.created_at)}</span>
          <span className="text-slate-500">Dari</span><span>{s.ref || s.source}</span>
          <span className="text-slate-500">Sisa</span><span>{Math.round(s.net_g || 0)} g</span>
          <span className="text-slate-500">Status</span><span>{s.status}{s.machine_id ? " · di mesin" : ""}</span>
        </div>
      )}
    </Modal>
  );
};
